"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogisticApi = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
/* 此代码由工具自动生成,不要直接修改,以免下次生成会丢失 */
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var getApi_1 = tslib_1.__importDefault(require("../../getApi"));
var LogisticApi = /** @class */ (function () {
    function LogisticApi() {
        this.http = getApi_1.default('api_v1');
    }
    /**
     * 查询物流信息
     * @method GET 查询物流信息
     *
     */
    LogisticApi.prototype.Logistic = function () {
        return this.http
            .url("/api/Logistic")
            .addSecurityHeaders()
            .support('GET');
    };
    LogisticApi.diOptions = di_1.default.options({
        name: "LogisticApi",
        scope: "Singleton"
    });
    return LogisticApi;
}());
exports.LogisticApi = LogisticApi;
exports.default = LogisticApi;
